import { Tabs, Tab } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface GiftTabsProps {
  initialValue: number | null;
  // disableAll: boolean;
  callback: (isHandled: number | null) => void;
}
interface TabItem {
  label: string;
  isHandled: number | null;
}

const GiftTabs = ({ initialValue, callback }: GiftTabsProps) => {
  const [value, setValue] = React.useState<number | null>(initialValue);
  const { t } = useTranslation(['gift']);

  // TODO: Typa
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (_event: React.ChangeEvent<any>, newValue: number | null) => {
    setValue(newValue);
    callback(newValue);
  };

  const tabItems: TabItem[] = [
    {
      label: t('gift:tabs.all'),
      isHandled: null,
    },
    {
      label: t('gift:tabs.handled'),
      isHandled: 1,
    },
    {
      label: t('gift:tabs.notHandled'),
      isHandled: 0,
    },
  ];

  return (
    <Tabs
      value={value}
      textColor='primary'
      onChange={handleChange}
      aria-label='disabled tabs example'
      sx={{
        '& button': {
          textTransform: 'none',
        },
        '& .hasBadge': {
          pr: '2rem',
          '& .MuiBadge-badge': {
            right: '-10px',
            top: '-2px',
          },
        },
      }}
    >
      {tabItems.map((item) => (
        <Tab key={item.label} label={item.label} value={item.isHandled} />
      ))}
    </Tabs>
  );
};

export default GiftTabs;
